export const PROJECT_LIST_SORT_FIELDS = Object.freeze({
    STATUS: "status",
    LEAD_STATUS: "leadStatus",
    PIC: "pic",
});

const API_ORDER_BY_ANT_ORDER = {
    ASC: "ascend",
    DESC: "descend",
};

const normalizeApiOrder = (order) => {
    if (!order) {
        return null;
    }

    const normalized = String(order).toUpperCase();

    if (normalized === "ASC" || normalized === "ASCEND") {
        return "ASC";
    }

    if (normalized === "DESC" || normalized === "DESCEND") {
        return "DESC";
    }

    return null;
};

const normalizeTableOrder = (order) => {
    if (order === "ascend") {
        return "ASC";
    }

    if (order === "descend") {
        return "DESC";
    }

    return null;
};

export const getProjectListSortFromTableSorter = (sorter, activeTab = "confirmed") => {
    const activeSorter = Array.isArray(sorter)
        ? sorter.find((sorterItem) => sorterItem?.order)
        : sorter;
    const order = normalizeTableOrder(activeSorter?.order);

    if (!order) {
        return { orderBy: null, order: null };
    }

    const columnKey = activeSorter?.columnKey || activeSorter?.key || activeSorter?.field;

    if (columnKey === "pic") {
        return { orderBy: PROJECT_LIST_SORT_FIELDS.PIC, order };
    }

    if (columnKey === "status" || activeSorter?.field === "status" || activeSorter?.field === "lead") {
        return {
            orderBy: activeTab === "lead"
                ? PROJECT_LIST_SORT_FIELDS.LEAD_STATUS
                : PROJECT_LIST_SORT_FIELDS.STATUS,
            order,
        };
    }

    const fields = {
        id: 'id', name: 'name', docs: 'docs', estimatedBilling: 'estimatedBilling',
        totalInvoiced: 'totalInvoiced', vendorRevenue: 'vendorRevenue', agencyRevenue: 'agencyRevenue',
        campaignResults: 'campaignResults', finance: 'finance', proposal_date: 'proposalDate', created_at: 'createdAt',
        vendor_planned_usd: 'vendorPlanned', vendor_billed_usd: 'vendorBilled', creditExposure: 'creditExposure',
    };
    return fields[columnKey] ? { orderBy: fields[columnKey], order } : null;
};

export const applyProjectListSortParams = (params, sortState) => {
    const order = normalizeApiOrder(sortState?.order);

    if (!sortState?.orderBy || !order) {
        return params;
    }

    params.orderBy = sortState.orderBy;
    params.order = order;
    params.sortCurrency = sortState.currencyMode || "SGD";

    return params;
};

export const getProjectListSortOrderForColumn = (sortState, orderBy) => {
    if (sortState?.orderBy !== orderBy) {
        return null;
    }

    const order = normalizeApiOrder(sortState?.order);

    return order ? API_ORDER_BY_ANT_ORDER[order] : null;
};
